import Search from 'assets/img/icons/search.svg';
import Label from 'components/_parts/atoms/label';
import { FormikContext } from 'formik';
import PropTypes from 'prop-types';
import { X } from 'react-feather';
import { useTranslation } from 'react-i18next';
import WindowedSelect, { components } from 'react-windowed-select';
import styled from 'styled-components';
import ArrowOptionWla from 'assets/img/icons/arrow-wla-option.svg';
import { memo, useCallback, useContext } from 'react';
import { Hooks } from 'providers';
import { AsyncPaginate } from 'react-select-async-paginate';

const SelectMod = styled(WindowedSelect)`
  .react-select__control {
    height: 43px;
    flex-shrink: 0;
    border-radius: 30px;
    border: 1px solid #d7d7d7;
    color: #4f4f4f;
    font-family: Poppins;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    display: flex;
    justify-content: center;
  }
  .react-select__placeholder {
    color: #d7d7d7;
  }
  .react-select__input-container {
    font-family: Poppins;
    font-size: 12px;
    display: flex;
    justify-content: center;
  }
  .react-select__value-container {
    position: relative;
    overflow: hidden;
    padding: 2px 12px;
    box-sizing: border-box;
    justify-content: start;
    align-items: center !important;
    flex-direction: row;
    height: 40px;
  }
  .react-select__input-container {
    margin: 2px;
    padding-bottom: 2px;
    padding-top: 2px;
    color: hsl(0, 0%, 20%);
    box-sizing: border-box;
    position: absolute;
    left: 0;
    width: 100%;
  }
  .react-select__indicators {
  }
  .react-select__menu {
  }
  .react-select__menu-list {
  }
  .react-select__option {
  }
  .react-select-fte__control {
    height: 45px;
    flex-shrink: 0;
    border-radius: 30px;
    border: 1px solid #d7d7d7;
    background: #ffffff;
    color: #4f4f4f;
    font-family: Poppins;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    padding: 0px 4px;
    display: flex;
    justify-content: center;
  }
  .react-select-fte__placeholder {
    color: #d7d7d7;
  }
  .react-select-fte__input-container {
    font-family: Poppins;
    font-size: 12px;
    display: flex;
    justify-content: center;
  }
  .react-select-fte__value-container {
    position: relative;
    overflow: hidden;
    padding: 2px 8px;
    box-sizing: border-box;
    justify-content: start;
    align-items: center !important;
    flex-direction: row;
    height: 40px;
  }
  .react-select-fte__input-container {
    margin: 2px;
    padding-bottom: 2px;
    padding-top: 2px;
    color: hsl(0, 0%, 20%);
    box-sizing: border-box;
    position: absolute;
    left: 0;
    width: 100%;
  }
  .react-select-fte__indicator {
    padding: 4px;
  }
  .react-select-fte__menu {
  }
  .react-select-fte__menu-list {
  }
  .react-select-fte__option {
  }
  .label-option {
    padding: 0 20px;
  }
  .react-select-wla__control {
    height: 35px;
    flex-shrink: 0;
    border-radius: 0px;
    border: 1px solid #d7d7d7;
    color: #4f4f4f;
    font-family: Poppins;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    display: flex;
    justify-content: center;
    border-radius: 12px !important;
    padding: 0px !important;
    padding-left: 5px !important;
    width: 100%;
  }
  .react-select-wla__control--is-focused {
    box-shadow: none !important;
  }
  .react-select-wla__placeholder {
    color: #d7d7d7;
  }
  .react-select-wla__input-container {
    font-family: Poppins;
    font-size: 12px;
    display: flex;
    justify-content: center;
  }
  .react-select-wla__value-container {
    position: relative;
    overflow: hidden;
    padding: 0px !important;
    box-sizing: border-box;
    justify-content: start;
    align-items: center !important;
    flex-direction: row;
    height: 40px;
  }
  .react-select-wla__input-container {
    margin: 2px;
    padding-bottom: 2px;
    padding-top: 2px;
    color: hsl(0, 0%, 20%);
    box-sizing: border-box;
    position: absolute;
    left: 0;
    width: 100%;
  }
  .react-select-wla__indicators {
  }
  .react-select-wla__menu {
    min-width: 250px;
  }
  .react-select-wla__menu-list {
  }
  .react-select-wla__option .label-option {
    color: #000000 !important;
  }
  .react-select-wla__option--is-focused .label-option {
    color: #000000 !important;
  }
  .react-select-wla__option--is-selected .label-option {
    color: #ffffff !important;
  }

  .label-option {
    padding: 0 20px;
  }
  .react-select-wla__single-value .label-option {
    color: #000000 !important;
    padding: 0 10px;
  }
`;
const SelectModPagination = styled(AsyncPaginate)`
  .react-select__control {
    height: 43px;
    flex-shrink: 0;
    border-radius: 30px;
    border: 1px solid #d7d7d7;
    color: #4f4f4f;
    font-family: Poppins;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    display: flex;
    justify-content: center;
  }
  .react-select__placeholder {
    color: #d7d7d7;
  }
  .react-select__input-container {
    font-family: Poppins;
    font-size: 12px;
    display: flex;
    justify-content: center;
  }
  .react-select__value-container {
    position: relative;
    overflow: hidden;
    padding: 2px 12px;
    box-sizing: border-box;
    justify-content: start;
    align-items: center !important;
    flex-direction: row;
    height: 40px;
  }
  .react-select__input-container {
    margin: 2px;
    padding-bottom: 2px;
    padding-top: 2px;
    color: hsl(0, 0%, 20%);
    box-sizing: border-box;
    position: absolute;
    left: 0;
    width: 100%;
  }
  .react-select__indicators {
  }
  .react-select__menu {
  }
  .react-select__menu-list {
  }
  .react-select__option {
  }
  .react-select-fte__control {
    height: 45px;
    flex-shrink: 0;
    border-radius: 30px;
    border: 1px solid #d7d7d7;
    background: #ffffff;
    color: #4f4f4f;
    font-family: Poppins;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    padding: 0px 4px;
    display: flex;
    justify-content: center;
  }
  .react-select-fte__placeholder {
    color: #d7d7d7;
  }
  .react-select-fte__input-container {
    font-family: Poppins;
    font-size: 12px;
    display: flex;
    justify-content: center;
  }
  .react-select-fte__value-container {
    position: relative;
    overflow: hidden;
    padding: 2px 8px;
    box-sizing: border-box;
    justify-content: start;
    align-items: center !important;
    flex-direction: row;
    height: 40px;
  }
  .react-select-fte__input-container {
    margin: 2px;
    padding-bottom: 2px;
    padding-top: 2px;
    color: hsl(0, 0%, 20%);
    box-sizing: border-box;
    position: absolute;
    left: 0;
    width: 100%;
  }
  .react-select-fte__indicator {
    padding: 4px;
  }
  .react-select-fte__menu {
  }
  .react-select-fte__menu-list {
  }
  .react-select-fte__option {
  }
  .label-option {
    padding: 0 20px;
  }
  .react-select-wla__control {
    height: 35px;
    flex-shrink: 0;
    border-radius: 0px;
    border: 1px solid #d7d7d7;
    color: #4f4f4f;
    font-family: Poppins;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    display: flex;
    justify-content: center;
    border-radius: 12px !important;
    padding: 0px !important;
    padding-left: 5px !important;
    width: 100%;
  }
  .react-select-wla__control--is-focused {
    box-shadow: none !important;
  }
  .react-select-wla__placeholder {
    color: #d7d7d7;
  }
  .react-select-wla__input-container {
    font-family: Poppins;
    font-size: 12px;
    display: flex;
    justify-content: center;
  }
  .react-select-wla__value-container {
    position: relative;
    overflow: hidden;
    padding: 0px !important;
    box-sizing: border-box;
    justify-content: start;
    align-items: center !important;
    flex-direction: row;
    height: 40px;
  }
  .react-select-wla__input-container {
    margin: 2px;
    padding-bottom: 2px;
    padding-top: 2px;
    color: hsl(0, 0%, 20%);
    box-sizing: border-box;
    position: absolute;
    left: 0;
    width: 100%;
  }
  .react-select-wla__indicators {
  }
  .react-select-wla__menu {
    min-width: 250px;
  }
  .react-select-wla__menu-list {
  }
  .react-select-wla__option .label-option {
    color: #000000 !important;
  }
  .react-select-wla__option--is-focused .label-option {
    color: #000000 !important;
  }
  .react-select-wla__option--is-selected .label-option {
    color: #ffffff !important;
  }

  .label-option {
    padding: 0 20px;
  }
  .react-select-wla__single-value .label-option {
    color: #000000 !important;
    padding: 0 10px;
  }
`;

const WrapperOptionFte = styled.div`
  max-height: 26px !important;
  max-height: 26px !important;
  border-radius: 20px !important;
  margin: 11px 0px !important;
  color: white;
  text-align: center;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${(props) => props.color_code ?? '#GGGGGG'};
`;

const getMatchIcon = (type) => {
  if (type === 'react-select-wla') return <img src={ArrowOptionWla} alt="search icon" />;
  return <img src={Search} alt="search icon" />;
};

export function IndicatorsContainer(props) {
  const { hideIcon, clearValue, isLoading } = props.selectProps;
  const formik = useContext(FormikContext);
  const { setBoardSw } = useContext(Hooks);
  function LoadingText() {
    return <span style={{ marginRight: '10px' }}>Loading...</span>;
  }
  const clearValueSelect = () => {
    if (formik) {
      formik.setFieldValue(props?.selectProps?.name, '');
      formik.setFieldValue(`${props?.selectProps?.name}_label`, '');
    }
  };
  return (
    <components.IndicatorsContainer {...props}>
      <components.DropdownIndicator {...props}>
        {isLoading && LoadingText()}
        {props?.hasValue
        && (props?.isClearable || props?.selectProps?.isClearable) ? (
          <X
            style={{ zIndex: '0', display: hideIcon ? 'none' : '' }}
            onClick={(e) => {
              e.preventDefault();
              formik !== undefined ? clearValueSelect() : setBoardSw('');
              if (clearValue) {
                clearValue();
              }
            }}
          />
          ) : (
            getMatchIcon(props?.selectProps?.classNamePrefix)
          )}
      </components.DropdownIndicator>
    </components.IndicatorsContainer>
  );
}

const findBoardOption = (label, status) => (
  <div className="d-flex flex-row justify-content-between w-100 align-items-center">
    <div className="ellipsis">{label}</div>
    <div className="status">{status}</div>
  </div>
);

const formatOptionLabel = ({
  label, color_code, status, type,
}) => {
  const typeOption = {
    findboard: () => findBoardOption(label, status),
  };
  const elementData = typeOption?.[type]?.() ?? label;
  return (
    <div style={{ display: 'flex' }}>
      <WrapperOptionFte color_code={color_code} className="label-option">
        {elementData}
      </WrapperOptionFte>
    </div>
  );
};
const findBoardOptionLabel = ({
  value, label, color_code, status,
}) => (
  <div style={{ display: 'flex' }}>
    <WrapperOptionFte color_code={color_code} className="label-option">
      {label}
    </WrapperOptionFte>
  </div>
);

export function Menu({ children, ...props }) {
  return (
    <components.Menu
      {...props}
      className="rs-menu layout_item_search"
      style={{ padding: '0px 30px' }}
    >
      {children}
    </components.Menu>
  );
}
function CustomInput({
  type,
  placeholder = '',
  style = {},
  id = '',
  value,
  hasValue = '',
  name,
  func = () => {},
  clearValue = () => {},
  validationMessage = '',
  isError = false,
  defaultValue = '',
  className = 'w-100',
  placeholderPosition = '',
  checked = false,
  typeCheckbox = 'success',
  disable = false,
  hideIcon = false,
  validateMessage = '',
  options = [],
  loadOptions = {},
  cacheUniqs,
  key = '',
  classNamePrefix = 'react-select',
  ...props
}) {
  const { t } = useTranslation();
  const getCustomInput = useCallback(() => {
    switch (type) {
      case 'text':
      case 'password': {
        const valueCustom = value !== undefined ? { value: value ?? '' } : { defaultValue };

        return (
          <div className="floating_custom">
            <input
              id={id}
              className={`floating_input ${className}`}
              type={type}
              name={name}
              placeholder=" "
              style={style}
              {...valueCustom}
              {...props}
            />
            <label htmlFor={id}>{placeholder}</label>
          </div>
        );
      }
      case 'textarea':
        return (
          <textarea
            id="input-text-area"
            className={`custom_text ${className} ${
              placeholderPosition === 'start'
                ? 'start_placeholder'
                : 'center_placeholder'
            }`}
            name={name}
            placeholder={placeholder}
            style={style}
            value={value}
            defaultValue={defaultValue}
            {...props}
          />
        );

      case 'search':
      case 'dropdown':
        return (
          <div
            className={`layout_search floating_custom ${
              disable ? 'isDisable' : ''
            }`}
          >
            <input
              id={id}
              className={`custom_search floating_input pr-5 ${className}`}
              type="text"
              name={name}
              placeholder=" "
              style={style}
              value={value}
              defaultValue={defaultValue}
              disabled={disable}
              {...props}
            />
            <label htmlFor={id}>{placeholder}</label>
            {type === 'search' && !disable && (
              <img src={Search} alt="search icon" className="custom_icon" />
            )}
          </div>
        );

      case 'dropdown-windowed':
        return (
          <div
            className={`floating_custom ${disable ? 'disable' : 'noDisable'} ${
              hasValue ? 'hasValueDropdown' : ''
            }`}
          >
            <SelectMod
              id={id}
              isClearable
              classNamePrefix={classNamePrefix}
              className="react-select-container"
              options={options}
              formatOptionLabel={
                classNamePrefix !== 'react-select' && formatOptionLabel
              }
              placeholder=" "
              name={name}
              onChange={(e) => {
                func();
              }}
              components={{ IndicatorsContainer, Menu }}
              value={value}
              defaultValue={defaultValue}
              isDisabled={disable}
              selectProps={{
                ...props,
                hideIcon,
                clearValue,
              }}
              noOptionsMessage={() => t('org.structure_view.personel.form.p_option')}
              {...props}
            />
            <label htmlFor={id}>{placeholder}</label>
          </div>
        );
      case 'dropdown-pagination':
        return (
          <div
            className={`floating_custom ${disable ? 'disable' : 'noDisable'} ${
              hasValue ? 'hasValueDropdown' : ''
            }`}
          >
            <SelectModPagination
              id={id}
              key={key}
              isClearable
              classNamePrefix={classNamePrefix}
              className="react-select-container"
              loadOptions={loadOptions}
              debounceTimeout={300}
              formatOptionLabel={
                classNamePrefix !== 'react-select' && formatOptionLabel
              }
              additional={{
                page: 1, // Initial page number
              }}
              cacheUniqs={[props?.cacheUniqs]}
              placeholder=" "
              name={name}
              onChange={props?.onChange}
              components={{
                IndicatorsContainer,
                Menu,
              }}
              value={value}
              defaultValue={defaultValue}
              isDisabled={disable}
              selectProps={{
                ...props,
                hideIcon,
                clearValue,
              }}
              noOptionsMessage={
                props?.noOptionsMessage
                || (() => t('org.structure_view.personel.form.p_option'))
              }
              {...props}
            />
            <label htmlFor={id}>{placeholder}</label>
          </div>
        );

      case 'number':
        return (
          <div className="floating_custom">
            <input
              id={id}
              className={`floating_input hide_arrow ${className} ${
                placeholderPosition === 'start'
                  ? 'start_placeholder'
                  : 'center_placeholder'
              }`}
              type="number"
              name={name}
              placeholder=" "
              style={style}
              value={value}
              defaultValue={defaultValue}
              {...props}
            />
            <label htmlFor={id}>{placeholder}</label>
          </div>
        );

      case 'email':
        return (
          <div className="floating_custom">
            <input
              id={id}
              className={`floating_input hide_arrow ${className} ${
                placeholderPosition === 'start'
                  ? 'start_placeholder'
                  : 'center_placeholder'
              }`}
              type="email"
              name={name}
              placeholder=" "
              style={style}
              value={value}
              defaultValue={defaultValue}
              {...props}
            />
            <label htmlFor={id}>{placeholder}</label>
          </div>
        );

      case 'checkbox':
        return (
          <div className="checkbox-container" style={style}>
            <input type="checkbox" id="custom-checkbox" {...props} />
            <label
              htmlFor="custom-checkbox"
              className={`${
                checked
                  ? typeCheckbox === 'error'
                    ? 'checked_error'
                    : 'checked_success'
                  : 'color_transparent'
              } ${
                typeCheckbox === 'error'
                  ? 'checkmark_error'
                  : 'checkmark_success'
              } `}
              style={{ userSelect: 'none' }}
            >
              {typeCheckbox === 'error' ? 'X' : '✓'}
            </label>
          </div>
        );

      default:
        break;
    }
  }, [
    type,
    placeholderPosition,
    className,
    name,
    placeholder,
    style,
    value,
    defaultValue,
    props,
    func,
    disable,
    typeCheckbox,
    checked,
    classNamePrefix,
    options,
    t,
    hideIcon,
    props?.loadOptions,
  ]);

  return (
    <>
      {getCustomInput()}
      {isError && validateMessage !== undefined ? (
        <Label className="error d-block text-left maxWidth250px label_error">
          {validateMessage}
        </Label>
      ) : null}
    </>
  );
}

export default memo(CustomInput);

CustomInput.propTypes = {
  style: PropTypes.object,
};

CustomInput.default = {
  style: { width: '100%' },
};
